@if (!addNewDevice) {
  <div class="main-container">
    <!-- Header Section -->
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title">Dispatched Devices</span>
      </div>
      <!-- Redirect Button -->
      <div class="button-group">
        @if (dispatchDeviceCreate) {
          <button
            type="button"
            class="primary-button"
            (click)="addNewDeviceFunc()"
          >
            Add Dispatched Devices
            <mat-icon class="btn-icon">open_in_new</mat-icon>
          </button>
        }
      </div>
    </div>

    <div class="component-container">
      <!-- List Section -->
      <form [formGroup]="dispatchDeviceForm" novalidate>
        <div class="component-header">
          <h6 class="component-title">Dispatched Device List</h6>
          <div class="component-actions">
            <button
              type="button"
              class="primary-button"
              [disabled]="isDownloading"
              (click)="downloadDispatchDeviceReport()"
            >
              Export<mat-icon class="btn-icon">download</mat-icon>
            </button>
            <app-common-search
              [initialSearchValue]="
                dispatchDeviceForm?.get('dispatchDeviceSearch')?.value
              "
              matTooltip="UIN NO. | IMEI NO. | ICCID NO. | Device Model"
              (searchSubmit)="onSearch($event)"
            ></app-common-search>
          </div>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->
        <div class="component-body">
          <table>
            <tr>
              <th>UIN NO.</th>
              <th>IMEI NO.</th>
              <th>ICCID NO.</th>
              <th>Device Model</th>
              <th>TML Part NO.</th>
              @if (dispatchDeviceDelete && dispatchDeviceUpdate) {
                <th>Action</th>
              }
            </tr>
            @if (dispatchDeviceList.length !== 0) {
              <tbody>
                @for (
                  dispatchDevice of dispatchDeviceList
                    | paginate
                      : {
                          id: 'user_pagination',
                          itemsPerPage: size,
                          currentPage: page,
                          totalItems: totalLength,
                        };
                  track dispatchDevice
                ) {
                  <tr>
                    <td>
                      {{ dispatchDevice.uid }}
                    </td>
                    <td>
                      {{ dispatchDevice.imei }}
                    </td>
                    <td>
                      {{ dispatchDevice.iccid }}
                    </td>
                    <td>
                      {{
                        dispatchDevice.modelName
                          ? dispatchDevice.modelName
                          : '--'
                      }}
                    </td>
                    <td>
                      {{ dispatchDevice.TMLPN ? dispatchDevice.TMLPN : '--' }}
                    </td>
                    <td>
                      <div class="action-buttons">
                        @if (dispatchDeviceUpdate) {
                          <button
                            class="primary-button view-button"
                            type="button"
                            (click)="prePopulation1(dispatchDevice)"
                          >
                            <mat-icon class="btn-icon">visibility</mat-icon>
                          </button>
                        }
                        @if (dispatchDeviceDelete) {
                          <button
                            type="button"
                            class="primary-button delete-button"
                            (click)="deleteDispatchedDevice(dispatchDevice)"
                          >
                            <mat-icon class="btn-icon">delete</mat-icon>
                          </button>
                        }
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (dispatchDeviceList.length === 0) {
              <tbody>
                <tr>
                  <td colspan="7">
                    <img
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>

        <!-- Separator between Body and Footer -->
        <div class="component-separator"></div>

        <!-- Component Footer Section (Optional) -->
        <div class="component-footer">
          @if (totalLength !== 0) {
            <app-common-component-pagination
              [totalItems]="totalLength"
              [pageSize]="size"
              [currentPage]="page"
              [totalPages]="totalLength"
              (pageChange)="onPageChange($event)"
              (sizeChange)="onSizeChange($event)"
            >
            </app-common-component-pagination>
          }
        </div>
      </form>
    </div>
  </div>
}

<!-- Add/Edit Dispatch Form Section -->
@if (addNewDevice) {
  <div class="main-container">
    <!-- Header Section -->
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="cancelFunc()"
          tabindex="0"
          (keydown.enter)="cancelFunc()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="prePopulation(selectedDispatchDevice)"
          tabindex="0"
          (keydown.enter)="prePopulation(selectedDispatchDevice)"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title">Dispatched Device Details</span>
      </div>
    </div>

    <div class="component-container">
      <form [formGroup]="dispatchDeviceForm" novalidate>
        <!-- Form Section -->
        <div class="component-header">
          <h6 class="component-title">Edit Dispatched Device Details</h6>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->
        <div class="component-body">
          <div class="form-section">
            <div class="form-group">
              <label for="UIN" class="form-label">UIN</label>
              <mat-form-field appearance="outline">
                <mat-label>UIN</mat-label>
                <input
                  matInput
                  id="UIN"
                  type="text"
                  placeholder="UIN"
                  formControlName="UIN"
                  required
                />
                @if (
                  dispatchDeviceForm.controls['UIN'].touched &&
                  dispatchDeviceForm.controls['UIN'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dispatchDeviceForm.controls['UIN'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
                @if (
                  dispatchDeviceForm.controls['UIN'].touched &&
                  dispatchDeviceForm.controls['UIN'].errors
                    ?.exactLengthValidator
                ) {
                  <mat-error>
                    {{
                      dispatchDeviceForm.controls['UIN'].errors
                        ?.exactLengthValidator
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="IMEI" class="form-label">IMEI</label>
              <mat-form-field appearance="outline">
                <mat-label>IMEI</mat-label>
                <input
                  matInput
                  id="IMEI"
                  formControlName="IMEI"
                  placeholder="IMEI"
                  required
                />
                @if (
                  dispatchDeviceForm.controls['IMEI'].touched &&
                  dispatchDeviceForm.controls['IMEI'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dispatchDeviceForm.controls['IMEI'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
                @if (
                  dispatchDeviceForm.controls['IMEI'].touched &&
                  dispatchDeviceForm.controls['IMEI'].errors
                    ?.exactLengthValidator
                ) {
                  <mat-error>
                    {{
                      dispatchDeviceForm.controls['IMEI'].errors
                        ?.exactLengthValidator
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="form-group">
              <label for="ICCID" class="form-label">ICCID</label>
              <mat-form-field appearance="outline">
                <mat-label>ICCID</mat-label>
                <input
                  matInput
                  id="ICCID"
                  formControlName="ICCID"
                  placeholder="ICCID"
                  required
                />
                @if (
                  dispatchDeviceForm.controls['ICCID'].touched &&
                  dispatchDeviceForm.controls['ICCID'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dispatchDeviceForm.controls['ICCID'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
                @if (
                  dispatchDeviceForm.controls['ICCID'].touched &&
                  dispatchDeviceForm.controls['ICCID'].errors
                    ?.exactLengthValidator
                ) {
                  <mat-error>
                    {{
                      dispatchDeviceForm.controls['ICCID'].errors
                        ?.exactLengthValidator
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="TMLPN" class="form-label">TML Part Number</label>
              <mat-form-field appearance="outline">
                <mat-label>TML Part Number</mat-label>
                <input
                  matInput
                  id="TMLPN"
                  placeholder="TML Part Number"
                  formControlName="TMLPN"
                  required
                />
                @if (
                  dispatchDeviceForm.controls['TMLPN'].touched &&
                  dispatchDeviceForm.controls['TMLPN'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dispatchDeviceForm.controls['TMLPN'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="TCUModel" class="form-label">TCU Model</label>
              <mat-form-field appearance="outline">
                <mat-label>TCU Model</mat-label>
                <mat-select formControlName="TCUModel" id="TCUModel" required>
                  @if (isTCUModelMissingFromList()) {
                    <mat-option
                      [value]="dispatchDeviceForm.controls['TCUModel'].value"
                    >
                      {{ dispatchDeviceForm.controls['TCUModel'].value }}
                    </mat-option>
                  }
                  @for (m of deviceModelList; track m._id) {
                    <mat-option [value]="m.modelName">
                      {{ m.modelName }}
                    </mat-option>
                  }
                </mat-select>
                @if (
                  dispatchDeviceForm.controls['TCUModel'].touched &&
                  dispatchDeviceForm.controls['TCUModel'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dispatchDeviceForm.controls['TCUModel'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="ProdDate" class="form-label">Production Date</label>
              <mat-form-field appearance="outline">
                <mat-label>Production Date</mat-label>
                <input
                  formControlName="ProdDate"
                  matInput
                  [matDatepicker]="ProdDate"
                  id="ProdDate"
                  placeholder="Production Date"
                  readonly
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="ProdDate"
                ></mat-datepicker-toggle>
                <mat-datepicker #ProdDate></mat-datepicker>
                <mat-error> This field is required </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="TCUTestStatus" class="form-label"
                >TCU Test Status</label
              >
              <mat-form-field appearance="outline">
                <mat-label>TCU Test Status</mat-label>
                <input
                  matInput
                  id="TCUTestStatus"
                  placeholder="TCU Test Status"
                  formControlName="TCUTestStatus"
                  required
                />
                @if (
                  dispatchDeviceForm.controls['TCUTestStatus'].touched &&
                  dispatchDeviceForm.controls['TCUTestStatus'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dispatchDeviceForm.controls['TCUTestStatus'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="TCUFirmwareVersion" class="form-label"
                >TCU Firmware Version</label
              >
              <mat-form-field appearance="outline">
                <mat-label>TCU Firmware Version</mat-label>
                <input
                  matInput
                  id="TCUFirmwareVersion"
                  placeholder="TCU Firmware Version"
                  formControlName="TCUFirmwareVersion"
                  required
                />
                @if (
                  dispatchDeviceForm.controls['TCUFirmwareVersion'].touched &&
                  dispatchDeviceForm.controls['TCUFirmwareVersion'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dispatchDeviceForm.controls['TCUFirmwareVersion'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="BootstrapExpDate" class="form-label"
                >Bootstrap Expiry Date</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Bootstrap Expiry Date</mat-label>
                <input
                  formControlName="BootstrapExpDate"
                  matInput
                  [matDatepicker]="BootstrapExpDate"
                  id="BootstrapExpDate"
                  placeholder="Bootstrap Expiry Date"
                  readonly
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="BootstrapExpDate"
                ></mat-datepicker-toggle>
                <mat-datepicker #BootstrapExpDate></mat-datepicker>
                <mat-error> This field is required </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="SIMServiceOperator" class="form-label"
                >SIM Service Operator</label
              >
              <mat-form-field appearance="outline">
                <mat-label>SIM Service Operator</mat-label>
                <input
                  matInput
                  id="SIMServiceOperator"
                  placeholder="SIM Service Operator"
                  formControlName="SIMServiceOperator"
                  required
                />
                @if (
                  dispatchDeviceForm.controls['SIMServiceOperator'].touched &&
                  dispatchDeviceForm.controls['SIMServiceOperator'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dispatchDeviceForm.controls['SIMServiceOperator'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="EmissionType" class="form-label">Emission Type</label>
              <mat-form-field appearance="outline">
                <mat-label>Emission Type</mat-label>
                <input
                  matInput
                  id="EmissionType"
                  placeholder="Emission Type"
                  formControlName="EmissionType"
                  required
                />
                @if (
                  dispatchDeviceForm.controls['EmissionType'].touched &&
                  dispatchDeviceForm.controls['EmissionType'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dispatchDeviceForm.controls['EmissionType'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="SIMVendor" class="form-label">SIM Vendor</label>
              <mat-form-field appearance="outline">
                <mat-label>SIM Vendor</mat-label>
                <input
                  matInput
                  id="SIMVendor"
                  placeholder="SIM Vendor"
                  formControlName="SIMVendor"
                  required
                />
                @if (
                  dispatchDeviceForm.controls['SIMVendor'].touched &&
                  dispatchDeviceForm.controls['SIMVendor'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dispatchDeviceForm.controls['SIMVendor'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="tmlstatus" class="form-label">TML Status</label>
              <mat-form-field appearance="outline">
                <mat-label>TML Status</mat-label>
                <input
                  matInput
                  id="tmlstatus"
                  placeholder="TML Status"
                  formControlName="tmlstatus"
                  required
                />
                @if (
                  dispatchDeviceForm.controls['tmlstatus'].touched &&
                  dispatchDeviceForm.controls['tmlstatus'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dispatchDeviceForm.controls['tmlstatus'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Separator between Body and Footer -->
        <div class="component-separator"></div>

        <!-- Component Footer Section (Optional) -->
        <div class="component-footer">
          <div class="button-group">
            <button type="button" (click)="save()" class="edit-button">
              Update Dispatched Device Details
              <mat-icon class="btn-icon">edit</mat-icon>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
}
